const CONTENT_ROW_HEIGHT_ADJUSTMENT_PX = 15;

/**
 * When the title column wraps long text, its rows can grow taller than the
 * corresponding rows in the content column (separate <table> elements in a flex
 * container). Read heights from the live DOM and write them onto the content
 * cells so both columns align (export preview, html2canvas capture, etc.).
 */
export const syncSpreadsheetTitleContentRowHeights = (
  titlesContainer: HTMLElement,
  contentContainer: HTMLElement
): void => {
  const titleRows = Array.from(titlesContainer.querySelectorAll<HTMLTableRowElement>('table tbody tr'));
  const contentRows = Array.from(contentContainer.querySelectorAll<HTMLTableRowElement>('table tbody tr'));

  titleRows.forEach((titleRow, index) => {
    const contentRow = contentRows[index];
    if (!contentRow) {
      return;
    }

    const titleHeight = titleRow.offsetHeight;
    if (titleHeight <= contentRow.offsetHeight) {
      return;
    }

    Array.from(contentRow.cells).forEach(cell => {
      const cellEl = cell as HTMLElement;
      cellEl.style.boxSizing = 'border-box';
      cellEl.style.height = `${titleHeight + CONTENT_ROW_HEIGHT_ADJUSTMENT_PX}px`;
      cellEl.style.verticalAlign = 'middle';
    });

    const residual = Number(contentRow.offsetHeight) - Number(titleRow.offsetHeight);
    if (residual > 0) {
      Array.from(contentRow.cells).forEach(cell => {
        const cellEl = cell as HTMLElement;
        const parsedHeight = Number.parseFloat(cellEl.style.height);
        if (!Number.isNaN(parsedHeight)) {
          cellEl.style.height = `${parsedHeight - residual}px`;
        }
      });
    }
  });
};

/** Runs {@link syncSpreadsheetTitleContentRowHeights} for every titles/content pair under `root`. */
export const syncSpreadsheetTitleContentRowHeightsInSubtree = (root: HTMLElement): void => {
  root.querySelectorAll<HTMLElement>('.titles-columns-container').forEach(titlesContainer => {
    const parent = titlesContainer.parentElement;
    if (!parent) {
      return;
    }

    const contentContainer = parent.querySelector<HTMLElement>('[id="spreadsheet-table__content-columns"]');
    if (!contentContainer) {
      return;
    }

    syncSpreadsheetTitleContentRowHeights(titlesContainer, contentContainer);
  });
};
